<!-- =========================================================================================
  File Name: InstituteAddForm.vue
  Description: Institute Add Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="* 학원명" v-model="instituteName" v-validate="'required|max:25'" name="instituteName" required />
        <span class="text-danger text-sm" v-show="errors.has('instituteName')">{{ errors.first('instituteName') }}</span>

        <vs-input class="w-full mt-4" label="* 캠퍼스명" v-model="campusName" v-validate="'required|max:25'" name="campusName" />
        <span class="text-danger text-sm" v-show="errors.has('campusName')">{{ errors.first('campusName') }}</span>

        <vs-input class="w-full mt-4" label="* 계약자명" v-model="contractorName" v-validate="'required|max:25'" name="contractorName" />
        <span class="text-danger text-sm" v-show="errors.has('contractorName')">{{ errors.first('contractorName') }}</span>

        <vs-input class="w-full mt-4" label="* 계약자와의 관계" v-model="contractorRelation" v-validate="'required|max:25'" name="contractorRelation" />
        <span class="text-danger text-sm" v-show="errors.has('contractorRelation')">{{ errors.first('contractorRelation') }}</span>

        <vs-input class="w-full mt-4" label="* 학원장명" v-model="presidentName" v-validate="'required|max:25'" name="presidentName" />
        <span class="text-danger text-sm" v-show="errors.has('presidentName')">{{ errors.first('presidentName') }}</span>

        <vs-input class="w-full mt-4" label="* 사업자와의 관계" v-model="presidentRelation" v-validate="'required|max:25'" name="presidentRelation" />
        <span class="text-danger text-sm" v-show="errors.has('presidentRelation')">{{ errors.first('presidentRelation') }}</span>

        <vs-input class="w-full mt-4" label="* 사업자번호" v-model="businessNumber" v-validate="'required|max:25'" name="businessNumber" />
        <span class="text-danger text-sm" v-show="errors.has('businessNumber')">{{ errors.first('businessNumber') }}</span>

        <vs-input class="w-full mt-4" label="* 전화 번호" v-model="telephone" v-validate="'required|max:25'" name="telephone" />
        <span class="text-danger text-sm" v-show="errors.has('telephone')">{{ errors.first('telephone') }}</span>

        <vs-input class="w-full mt-4" label="* 이동전화번호" v-model="mobilephone " v-validate="'required|max:25'" name="mobilephone" />
        <span class="text-danger text-sm" v-show="errors.has('mobilephone')">{{ errors.first('mobilephone') }}</span>

        <vs-input class="w-full mt-4" label="팩스 번호" v-model="fax" name="fax" />
        <span class="text-danger text-sm" v-show="errors.has('fax')">{{ errors.first('fax') }}</span>

        <vs-input class="w-full mt-4" label="* 대표이메일" v-model="eMail" type="email" v-validate="'required|max:25|email'" name="eMail" />
        <span class="text-danger text-sm" v-show="errors.has('eMail')">{{ errors.first('eMail') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">  
        <vs-input class="w-full mt-4" label="* 학원장ID" v-model="instituteChiefID" v-validate="'required|max:25'" name="instituteChiefID" />
        <span class="text-danger text-sm" v-show="errors.has('instituteChiefID')">{{ errors.first('instituteChiefID') }}</span>

        <div class="flex flex-wrap mt-4">
          <div class="w-1/2">
            <vs-input class="w-full" label="우편번호" disabled v-model="zipCode" v-validate="'required|max:25'" name="zipCode" />
            <span class="text-danger text-sm" v-show="errors.has('zipCode')">{{ errors.first('zipCode') }}</span>
          </div>
          <div class="w-1/2">
            <vs-button class="mt-5 ml-4" @click="popupActive=true">주소 검색</vs-button>
          </div>
        </div>

       
        <vs-input class="w-full mt-4" label="주소" disabled v-model="zipName" v-validate="'required|max:25'" name="zipName" />
        <span class="text-danger text-sm" v-show="errors.has('zipName')">{{ errors.first('zipName') }}</span>

        <vs-input class="w-full mt-4" label="주소세부" v-model="zipDetail" name="zipDetail" />
        <span class="text-danger text-sm" v-show="errors.has('zipDetail')">{{ errors.first('zipDetail') }}</span>

        <div class="mt-4">
          <label class="ml-2 text-sm">가맹 계약일</label>
          <datepicker :language="languages.ko" v-model="frContractDate" format="yyyy-MM-dd"></datepicker>
          <span class="text-danger text-sm" v-show="errors.has('frContractDate')">{{ errors.first('frContractDate') }}</span>
        </div>

        <!-- <vs-input class="w-full mt-4" label="검색주소" v-model="addressSearch" name="addressSearch" />
        <span class="text-danger text-sm" v-show="errors.has('addressSearch')">{{ errors.first('addressSearch') }}</span> -->
        
        <!-- <vs-input class="w-full mt-4" label="도메인" v-model="domain" name="domain" />
        <span class="text-danger text-sm" v-show="errors.has('domain')">{{ errors.first('domain') }}</span> -->

        <vs-input class="w-full mt-4" label="캠퍼스 특이사항 메모" v-model="memo" name="memo" />
        <span class="text-danger text-sm" v-show="errors.has('memo')">{{ errors.first('memo') }}</span>
        
        <!-- <div class="mt-4">
          <label class="text-sm">홈페이지노출</label>
          <div class="mt-2">
            <vs-radio v-model="displayChk" vs-value="Y" class="mr-4">보이게 함</vs-radio>
            <vs-radio v-model="displayChk" vs-value="N" class="mr-4">안보이게 함</vs-radio>
          </div>
        </div> -->

    </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSave" :disabled="!validateForm">저장</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>

    <!-- Daum 우편번호 서비스 -->
    <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
      <p>
        <vue-daum-postcode @complete="this.daumPostCode" />
      </p>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'
import moment from 'moment'
import { VueDaumPostcode } from 'vue-daum-postcode'

import { postData } from '@/api/module'

export default {
  components: {
    vSelect,
    Datepicker,
    VueDaumPostcode
  },
  data () {
    return {
      languages: lang,
      popupActive: false,
      instituteName: '',
      addressSearch: '',
      branchSeq: 0,
      businessNumber: '',
      campusName: '',
      contractorName: '',
      contractorRelation: '',
      createDate: '',
      discount: 0,
      discountMethod: '',
      displayChk: '',
      domain: '',
      eMail: '',
      fax: '',
      frContractDate: '',
      instituteChiefID: '',
      instituteSeq: 0,
      memo: '',
      mobilephone: '',
      presidentName: '',
      presidentRelation: '',
      reserveMoney: 0,
      telephone: '',
      zipCode: '',
      zipDetail: '',
      zipName: ''
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.instituteName && this.businessNumber 
      && this.campusName && this.contractorName && this.contractorRelation 
      && this.eMail && this.instituteChiefID && this.mobilephone && this.presidentName 
      && this.presidentRelation && this.telephone && this.zipCode && this.zipName 
    }
  },
  methods: {
    daumPostCode (value) {
      this.zipCode = value.zonecode
      this.zipName = value.address

      this.popupActive = false
    },
    confirmSave () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '학원 추가',
        text: '저장 하시겠습니까?',
        accept: this.save,
        acceptText: '저장'
      })
    },
    async save () {
      if (!this.validateForm) return
      try {
        this.frContractDate = moment(this.frContractDate).format('YYYY-MM-DD')

        const { data } = await postData('institute', {
          instituteName: this.instituteName,
          businessNumber: this.businessNumber,
          campusName: this.campusName,
          contractorName: this.contractorName,
          contractorRelation: this.contractorRelation,
          eMail: this.eMail,
          instituteChiefID: this.instituteChiefID,
          mobilephone: this.mobilephone,
          presidentName: this.presidentName,
          presidentRelation: this.presidentRelation,
          telephone: this.telephone,
          zipCode: this.zipCode,
          zipName: this.zipName,

          addressSearch: this.addressSearch, 
          displayChk: this.displayChk, 
          domain: this.domain, 
          fax: this.fax, 
          frContractDate: this.frContractDate, 
          memo: this.memo, 
          reserveMoney: this.reserveMoney, 
          zipDetail: this.zipDetail
        })
        console.log(data)
        this.$router.push('/institute/institute-list')
        this.showSaveSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '학원 추가',
        text: '저장 되었습니다.'
      })
    }
  }
}
</script>
